import TextField from "../../ui/TextField";
import { useState, useEffect, useRef } from "react";
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useInventarios } from "../../../context/Inventarios/InventariosContext";

export default function ModalEditarConteo3({
  open,
  row,
  onClose,
}) {
  const [conteo3, setConteo3] = useState(0);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  const { handleTomaEditarConteo3 } = useInventarios();

  useEffect(() => {
    if (open && row) {
      const c3 = Number(row.conteo3 ?? row.dConteo3 ?? 0);
      const c2 = Number(row.conteo2 ?? row.dConteo2 ?? 0);
      const c1 = Number(row.conteo1 ?? row.dConteo1 ?? 0);
      setConteo3(c3 > 0 ? c3 : c2 > 0 ? c2 : c1 > 0 ? c1 : 0);
    }
  }, [open, row]);

  const guardar = async () => {
    setLoading(true);
    try {
      const clave = row.clavearticulo?.trim() || row.sClaveArticulo?.trim();
      const medida = row.medida ?? row.dMedida ?? 0;
      await handleTomaEditarConteo3(clave, medida, Number(conteo3));
      onClose?.();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Editar Conteo 3</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            <strong>Artículo:</strong> {row?.clavearticulo || ""}
          </Typography>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            <strong>Descripción:</strong> {row?.descripcion || ""}
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            <strong>Medida:</strong> {row?.medida ?? ""}
          </Typography>
          <TextField autoComplete="off"
            label="Conteo 3"
            type="text"
            inputMode="numeric"
            enterKeyHint="enter"
            fullWidth
            value={conteo3}
            onChange={(e) => setConteo3(e.target.value)}
            disabled={loading}
            autoFocus
            inputRef={inputRef}
            onFocus={(e) => e.target.select()}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}>
            <Button onClick={onClose} disabled={loading}>
              Cancelar
            </Button>
            <Button variant="contained" onClick={guardar} disabled={loading}>
              {loading ? "Guardando..." : "Guardar"}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
